import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'description',
    label: i18n('entities.outcome.fields.description'),
    schema: schemas.string(
      i18n('entities.outcome.fields.description'),
      {},
    ),
  },
];